export default __webpack_public_path__ + "static/media/g2022-26.bda68f4f.jpeg";